import { fetchAll } from '@/api/dashboard'

const state = {
  all: [],
  isLoading: false
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      dispatch('overlay/show', true, { root: true })

      const dashboard = await fetchAll()
      commit('setAll', dashboard)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    } finally {
      dispatch('overlay/show', false, { root: true })
    }
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.isLoading = false
  },

  setAll (state, dashboard) {
    state.all = dashboard
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
